let store = {
    currentQuestionIndex: 0,
    currentSideQuestionIndex: null,
    showResults: false,
    zipCode: null,
    houseNumber: null,
    addition: null,
    kadaster: null,
    questionAnswers: [],
    questionInfo: []
};

export default store;
